import { HttpService } from '@/shared/services'
import DocumentGroup from '../models/DocumentGroup'
import UploadDocumentDto from '../services/dtos/UploadDocumentDto'
import CreateDocumentGroupDto from '../services/dtos/CreateDocumentGroupDto'
import List from '@/shared/dtos/List'
import UpdateDocumentGroupDto from './dtos/UpdateDocumentGroupDto'
import UpdateDocumentDto from './dtos/UpdateDocumentDto'
const http = new HttpService()

export const deleteDocumentGroup = async (groupId: string) => {
  const response = await http.delete(`/policies/group/${groupId}`)
  return response.data
}

export const updateDocuments = async (documentFiles: UpdateDocumentDto[]) => {
  const results = await Promise.all(
    documentFiles.map(async (documentFile) => {
      const formData = new FormData()

      formData.append('groupId', documentFile.groupId as string)
      if (documentFile.file !== undefined) {
        formData.append('file', documentFile.file as any)
      }

      if (documentFile.link_1 !== undefined) {
        formData.append('link_1', documentFile.link_1 as string)
      }

      if (documentFile.link_2 !== undefined) {
        formData.append('link_2', documentFile.link_2 as string)
      }

      try {
        const response = await http.put(
          `/policies/document/${documentFile.documentId}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )

        return {
          success: true,
          data: response.data,
        }
      } catch (error) {
        return {
          success: false,
          error: error,
        }
      }
    })
  )

  return results.some((result) => !result.success) ? false : true
}

export const getDocumentGroupsByPayrollConfigId = async (
  payrollConfigId: string,
  search?: string
) => {
  let url = `/policies/group/${payrollConfigId}`
  if (search !== undefined && search !== null) {
    url += `?search=${search}`
  }

  const response = await http.get<List<DocumentGroup[]>>(url)
  return response.data
}

export const createDocumentGroup = async (
  documentGroup: CreateDocumentGroupDto
) => {
  const response = await http.post<CreateDocumentGroupDto, string>(
    '/policies/group',
    documentGroup
  )
  return response.data
}

export const updateDocumentGroup = async (
  groupId: string,
  documentGroup: UpdateDocumentGroupDto
) => {
  const response = await http.put<UpdateDocumentGroupDto, string>(
    '/policies/group/' + groupId,
    documentGroup
  )
}

export const deleteDocumentService = async (documentIds: string[]) => {
  const results = await Promise.all(
    documentIds.map(async (documentId) => {
      try {
        const response = await http.delete(`/policies/document/${documentId}`)
        // Return whatever information you want from the response
        return {
          success: true,
          data: response.data,
        }
      } catch (error) {
        // Handle the error if needed
        return {
          success: false,
          error: error,
        }
      }
    })
  )

  return results.some((result) => !result.success) ? false : true
}

export const uploadDocumentService = async (
  documentGroups: UploadDocumentDto[]
) => {
  const results = await Promise.all(
    documentGroups.map(async (documentGroup) => {
      const formData = new FormData()
      formData.append('file', documentGroup.file as any)
      formData.append('link_1', documentGroup.link_1 as string)
      formData.append('link_2', documentGroup.link_2 as string)

      try {
        const response = await http.post(
          `/policies/group/${documentGroup.groupId}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )

        // Return whatever information you want from the response
        return {
          success: true,
          data: response.data,
        }
      } catch (error) {
        // Handle the error if needed
        return {
          success: false,
          error: error,
        }
      }
    })
  )

  return results.some((result) => !result.success) ? false : true
}
